import { render, staticRenderFns } from "./Intents.vue?vue&type=template&id=55f52343"
import script from "./Intents.vue?vue&type=script&lang=js"
export * from "./Intents.vue?vue&type=script&lang=js"
import style0 from "./Intents.vue?vue&type=style&index=0&id=55f52343&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports